<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="map1"></a><img alt="images" src="images/map1.jpg"/></p>
<p class="caption">Map 1. The Whole Theatre.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_introduction1.vue?58a477d4